import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import { useNavigate } from "react-router";
import RevampBanner from "../components/RevampBanner";
import finvolveLogo from "../icons/fvlogo.png";

export default function Home() {
  document.title = "Finvolve";
  const navigate = useNavigate();

  return (
    <Container component="main" maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
        }}
      >
        <img
          src={finvolveLogo}
          alt="Finvolve"
          style={{ maxWidth: "270px", maxHeight: "180px" }}
        />
        <RevampBanner part="both" />
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
            width: "100%",
          }}
        >
          <Button
            fullWidth
            variant="contained"
            onClick={() => navigate("/investor-login")}
          >
            Investor Login
          </Button>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate("/wealth-manager-login")}
          >
            Wealth Manager Login
          </Button>
        </Box>
      </Box>
    </Container>
  );
}
